/**
 * Where the selective (fire-sprinkler) pipe sensor is being attached.
 *
 * The question is asked during the connected flow (step-connected-pipe-question)
 * while the phone is joined to the sensor's setup network — no internet — so
 * the answer rides on the onboarding instance (`pipe_strap_location`) until the
 * after-setup questionnaire step submits it alongside the system-type answer.
 */

export const PIPE_STRAP_BRANCH = 'branch_line';
export const PIPE_STRAP_RISER = 'riser_pipe';
export const PIPE_STRAP_DECLINED = 'declined';

// Whether the answer means the pipe strap is actually being used.
export const isUsingPipeStrap = value =>
  value === PIPE_STRAP_BRANCH || value === PIPE_STRAP_RISER;

// Human-readable label stored in the questionnaire payload.
export const pipeStrapLabel = value => {
  if (value === PIPE_STRAP_BRANCH) return 'Branch Line';
  if (value === PIPE_STRAP_RISER) return 'Riser Pipe';
  return '';
};

// The naming-step quick pick matching the answer, so the name the user most
// likely wants arrives already selected on the naming step.
export const pipeStrapNamePreset = value => {
  if (value === PIPE_STRAP_BRANCH) return 'Branch Line';
  if (value === PIPE_STRAP_RISER) return 'Riser Room';
  return '';
};
